export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "powerbet-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "powerbet-themeWrapLive" */'./LiveThemeImporter'),
  },
};
